var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-card',{staticClass:"box-card",staticStyle:{"width":"100%"},attrs:{"shadow":"always"}},[_c('div',{staticStyle:{"margin":"40px"}},[_c('h1',[_vm._v("Initial Farm Offering (IFO)")]),_c('p',[_vm._v(" Launchpad offering participation in initial token distributions from the best upcoming Tezos based projects. ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }